import { apiClient } from '@/shared/api/client';
import { ENDPOINTS } from '@/shared/api/endpoints';

/**
 * `POST /auth/logout` tampoco pasa por el interceptor (usa @Res()).
 * Devuelve `{ success: true }` plano. No nos interesa el body, solo el status.
 */
export async function logout(): Promise<void> {
  await apiClient.post(ENDPOINTS.auth.logout);
}
